import {FBFieldBase} from "../../../Fields/Core/FBFieldBase";

export class PriceField {

    constructor(public Field:FBFieldBase,public Price:number=0)
    {

    }
}